export const API = {
  UPLOAD: {
    S3: '/api/uploadfiletos3/upload',
  },
  SITE_OVERLAP: {
    DEFAULT: '/api/siteoverlay',
    LOCATION: {
      FLOOR_OVERLAY: {
        DEFAULT: '/api/flooroverlay',
      },
    },
  },
  OPERATIONS: {
    SITES: {
      DEFAULT: '/api/siteoverlay/:interfaceId/sites',
    },
    FLOOR: {
      DEFAULT: '/api/floor',
    },
    STATION: {
      BASED_LOCATION: '/api/station/:interfaceId',
      BASED_STATION_LOCATION: '/api/station/program-station/:interfaceId',
      DEFAULT: '/api/station/:interfaceId/station-mapoverlay',
    },
    MARKER: {
      DEFAULT: '/api/marker',
    },
    CUSTOM_MARKER: {
      DEFAULT: '/api/markercustom',
    },
    MICRO_CLIMATE: {
      DEFAULT: '/api/etzone',
    },
  },
  CONFIG: {
    FLOOR_OVERLAY: {
      LIST_OF_FLOOR: '/api/flooroverlay/:floorId',
      LIST_OF_FLOOR_BY_INTERFACEID: '/api/flooroverlay',
    },
    STATION: {
      GET_LIST_WITH_DETAIL: (interfaceId: number) =>
        `/api/station/${interfaceId}/getlistwithdetail`,
      UPDATE: '/api/station/multi-stations',
    },
    SOIL_MOISTURE: {
      GET_LIST_WITH_DETAIL: (interfaceId: number) =>
        `/api/sensor/${interfaceId}/mapoverlay`,
      GET_LIST_WITH_DETAIL_DATA: (interfaceId: number, sensorId: number) =>
        `/api/sensor/mapoverlay/data?interfaceId=${interfaceId}&sensorId=${sensorId}`,
    },
    SENSOR: {
      GET_LIST_WITH_DETAIL: (interfaceId: number) =>
        `/api/flowsensor/${interfaceId}/mapoverlay`,
    },
  },
  CONFIG_SETUP: {
    DEFAULT: '/api/setup/:interfaceId',
    USER: {
      PROFILE: 'api/user/profile',
    },
    MEASURES: {
      DEFAULT: '/api/setup/measures',
    },
    TIME_ZONES: {
      DEFAULT: '/api/timezone',
    },
    COMMON_DATA: {
      DEFAULT: '/api/setup/:interfaceId/common-data',
      REFERENCE: {
        TEMPLATE: '/api/setup/:interfaceId/common-data/etreference',
        UPLOAD:
          '/api/setup/:interfaceId/common-data/etreference/upload?isDeleted=:isDeleted',
        DELETE: '/api/setup/:interfaceId/common-data/etreference/delete',
      },
      COMMON: {
        TEMPLATE: '/api/setup/:interfaceId/common-data/import-template',
        UPLOAD:
          '/api/setup/:interfaceId/common-data/upload/?type=:type&isDeleted=:isDeleted',
        DELETE: '/api/setup/:interfaceId/common-data/delete',
      },
      INIT: {
        UPLOAD:
          '/api/setup/:interfaceId/common-data/init/upload/?isDeleted=:isDeleted',
      },
      COMMON_DATA_STATION: {
        TEMPLATE: '/api/setup/:interfaceId/common-data/import-template',
        UPLOAD:
          '/api/setup/:interfaceId/common-data/upload/?type=:type&page=:page&isDeleted=:isDeleted',
        DELETE: '/api/setup/:interfaceId/common-data/delete',
      },

      HYDRAULIC: {
        UPLOAD:
          '/api/setup/:interfaceId/common-data/hydraulic/upload?isDeleted=:isDeleted',
      },
      PLANT: {
        TEMPLATE: '/api/setup/:interfaceId/common-data/plants',
        UPLOAD:
          '/api/setup/:interfaceId/common-data/plants/upload?isDeleted=:isDeleted',
        DELETE: '/api/setup/:interfaceId/common-data/plants/delete',
      },
      EMITTER: {
        TEMPLATE: '/api/setup/:interfaceId/common-data/emitters',
        UPLOAD:
          '/api/setup/:interfaceId/common-data/emitters/upload?isDeleted=:isDeleted',
        DELETE: '/api/setup/:interfaceId/common-data/emitters/delete',
      },
      SOIL: {
        TEMPLATE: '/api/setup/:interfaceId/common-data/soils',
        UPLOAD:
          '/api/setup/:interfaceId/common-data/soils/upload?isDeleted=:isDeleted',
        DELETE: '/api/setup/:interfaceId/common-data/soils/delete',
      },
      ETZONE: {
        TEMPLATE: '/api/setup/:interfaceId/common-data/et-zone',
        UPLOAD:
          '/api/setup/:interfaceId/common-data/et-zone/upload?isDeleted=:isDeleted',
        DELETE: '/api/setup/:interfaceId/common-data/et-zone/delete',
      },
      AREA: {
        TEMPLATE: '/api/setup/:interfaceId/common-data/area',
        UPLOAD:
          '/api/setup/:interfaceId/common-data/area/upload?isDeleted=:isDeleted',
        DELETE: '/api/setup/:interfaceId/common-data/area/delete',
      },
      STATION: {
        TEMPLATE: '/api/setup/:interfaceId/station-data',
        UPLOAD:
          '/api/setup/:interfaceId/station-data/upload?isDeleted=:isDeleted',
        DELETE: '/api/setup/:interfaceId/common-data/stations/delete',
      },
    },
    DISCOVER_DATA: {
      DEFAULT: '/api/setup/:interfaceId/discover-data',
    },
    SITE: {
      DEFAULT: '/api/site',
    },
    LOCATION: {
      DEFAULT: '/api/location',
    },
    CONTROLLER: {
      DEFAULT: '/api/controller',
    },
    STATION: {
      UPDATE: '/api/station/multi-stations',
    },
    SOIL_MOISTURE: {
      UPDATE: '/api/sensor/geotag-soil-moisture-sensor',
    },
    FLOW_SENSOR: {
      UPDATE: '/api/flowsensor/geotag-flow-sensor',
    },
  },
}

export const KEY_GOOGLE_MAP_TYPE = 'KEY_GOOGLE_MAP_TYPE'

export const ONE_MB = 1024 * 1024
export const FILE_MAXIMUM_FILE_OVERLAY = 15
export const LINK_OTHER_APP = {
  Irrigation: 'http://www.irrigation.com.sg/',
}

export const SignalR = {
  HUB: '/Hub',
}

export const TELEMETRY_API = 'https://telemetry.cisgenx.com/'
export const TELEMETRY_API_KEY = 'api-read-key-3456789012'

export const MAX_ZOOM_LEVEL = 21
